import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z","key":"svg-0"}],["path",{"d":"M14.424 15.03l-2.424 -3.03h6","key":"svg-1"}],["path",{"d":"M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z","key":"svg-2"}],["path",{"d":"M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z","key":"svg-3"}],["path",{"d":"M18 17l2 -2v6","key":"svg-4"}]]

const IconCarFan1 = createReactComponent('outline', 'car-fan-1', 'CarFan1', __iconNode);

export default IconCarFan1;